export enum MarginType {
    Login = 1
}